import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-report-designer',
  host: { class: 'flex-grow-1' },
  templateUrl: './report-designer.component.html',
  styleUrls: ['./report-designer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportDesignerComponent implements OnInit {
  reportDesignerUrl: SafeResourceUrl;
  private targetOrigin: string;
  private frameEl: HTMLIFrameElement | null = null;
  private lastSent: string | null = null;
  private pollId: number | null = null;
  private patchDone = false;

  constructor(private sanitizer: DomSanitizer) {
    this.targetOrigin = this.getOrigin(environment.telerikReportDesignerUrl);
  }

  ngOnInit(): void {
    const raw = environment.telerikReportDesignerUrl;

    const cacheBuster = 'v=' + Date.now();
    const sep = raw.indexOf('?') >= 0 ? '&' : '?';
    const withBuster = raw + sep + cacheBuster;

    this.reportDesignerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(withBuster);
}

  onFrameLoad(frameEl: HTMLIFrameElement): void {
    this.frameEl = frameEl;

    this.sendIfChanged();

    // Cross-tab changes
    window.addEventListener('storage', (e: StorageEvent) => {
      if (e.key === 'accessToken') {
        this.sendIfChanged();
      }
    });

    // Same-tab changes: patch localStorage & add fallback polling
    this.patchLocalStorageForTokenEvents();
    window.addEventListener('access-token-changed', () => this.sendIfChanged());
    this.pollId = window.setInterval(() => this.sendIfChanged(), 5000);

    // Optional handshake: reply when iframe asks
    window.addEventListener('message', (e: MessageEvent) => {
      if (e.origin === this.targetOrigin && e.data && e.data.kind === 'request-reporting-auth') {
        this.sendIfChanged(true);
      }
    });
  }

  private sendIfChanged(force?: boolean): void {
    if (!this.frameEl || !this.frameEl.contentWindow) {
      return;
    }

    const token = localStorage.getItem('accessToken');

    if (force || token !== this.lastSent) {
      this.frameEl.contentWindow.postMessage(
        { kind: 'reporting-auth', token: token },
        this.targetOrigin
      );
      this.lastSent = token;
    }
  }

  private patchLocalStorageForTokenEvents(): void {
    if (this.patchDone) {
      return;
    }

    this.patchDone = true;

    const origSet = localStorage.setItem;
    localStorage.setItem = function(k: string, v: string): void {
      origSet.apply(this, arguments as any);

      if (k === 'accessToken') {
        try {
          window.dispatchEvent(new CustomEvent('access-token-changed'));
        } catch (_) {}
      }
    };

    const origRemove = localStorage.removeItem;
    localStorage.removeItem = function(k: string): void {
      origRemove.apply(this, arguments as any);

      if (k === 'accessToken') {
        try {
          window.dispatchEvent(new CustomEvent('access-token-changed'));
        } catch (_) {}
      }
    };
  }

  private getOrigin(url: string): string {
    const a = document.createElement('a');
    a.href = url;
    return a.protocol + '//' + a.hostname + (a.port ? (':' + a.port) : '');
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/reporting/report-designer/report-designer.component.ts